import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  HeaderComponent,
  InterfaceComponentLinksMenu,
} from './shared/components/header/header.component';
import { KeycloakAuthService } from './shared/services/keycloack.service';
import { from, map, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CustomIconsService } from './shared/services/custom-icons.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  keycloakAuthService = inject(KeycloakAuthService);
  private _customIconsService = inject(CustomIconsService);
  HEADER_LINKS: InterfaceComponentLinksMenu[] = [
    {
      url: '/dashboard',
      title: 'Dashboard',
    },
    {
      url: '/sparten',
      title: 'Sparte',
    },
  ];

  constructor() {
    this._customIconsService.init();
  }

  isAuthenticated$: Observable<boolean> = this.keycloakAuthService.isLoggedIn();

  links$: Observable<InterfaceComponentLinksMenu[]> =
    this.isAuthenticated$.pipe(
      map((loggedIn) => (loggedIn ? this.HEADER_LINKS : []))
    );
}
